// ============================================
// 悬停高亮状态（2026-09-14｜方案A 抑制组合）
// 背景：原实现悬停=整个模型染色（#40a9ff×0.05），大模型占满屏幕时全屏色差。
// 主流调研：Blender/Unity 对象级悬停干脆不做；UE/three.js/SolidWorks/Babylon 用描边；
// Fusion 360 整面染色被大量投诉"大面积物体常亮刺眼"。
// 本 store 承载抑制策略的共享状态：
// - hoveredId：当前悬停模型（单实例）
// - suppressed：相机导航/部件拖拽/大屏编辑锁定期间抑制悬停（对齐 Blender「导航时关闭预选」）
// ============================================

import { create } from 'zustand';

interface HoverState {
  hoveredId: string | null;
  suppressed: boolean;
  setHovered: (id: string | null) => void;
  /** 抑制期间同时清除当前悬停（恢复后需指针再次移动才会重新悬停） */
  setSuppressed: (v: boolean) => void;
}

export const useHoverStore = create<HoverState>((set) => ({
  hoveredId: null,
  suppressed: false,
  setHovered: (id) => set({ hoveredId: id }),
  setSuppressed: (v) => set((s) => ({ suppressed: v, hoveredId: v ? null : s.hoveredId })),
}));
